<div (openChange)="emit(dropdown.isOpen())"
     autoClose="outside"
     class="filter-dropdown"
     ngbDropdown>
    <app-tooltip [dynamic]="false"
                 class="display-inline-flex"
                 message="Filter">
        <button [attr.data-cy]="getCypressTagElement('button')"
                [ngClass]="getCssButton()"
                class="filter filter-icon iwp-icon-gen_filter"
                ngbDropdownToggle
                tabIndex="-1"
                type="button"></button>
    </app-tooltip>
    <form [attr.data-cy]="getCypressTagElement('dropdown')"
          [formGroup]="form"
          class="filter-menu"
          ngbDropdownMenu
          placement="'bottom-right'">

        <div class="filter-all">
            <app-input-text #searchInput
                            (inputValueChange)="updateSearchValue($event)"
                            (keydown.enter)="closeAndSearch()"
                            [alternateBackground]="true"
                            [baseCypressTag]="getCypressTag()"
                            [hasLabel]="false"
                            [hasSearchIcon]="true"
                            [placeholder]="placeholder"
                            class="filter-search-input">
            </app-input-text>
        </div>


        <div [attr.data-cy]="getCypressTagElement('dropdown-option')" class="filter-option filter-item" ngbDropdownItem>
            <input (keydown.enter)="closeAndSearch()"
                   [checked]="true"
                   [value]="NumberFilterOptionEnum.ALL"
                   formControlName="option"
                   id="{{filterName}}-all"
                   name="option"
                   type="radio">
            <label class="filter-option-label" for="{{filterName}}-all">All</label>
        </div>
        <div class="separator"></div>
        <div [attr.data-cy]="getCypressTagElement('dropdown-option')" class="filter-option no-hover" ngbDropdownItem>
            <input (keydown.enter)="closeAndSearch()"
                   [attr.data-cy]="getCypressTagElement('dropdown-operator')"
                   [value]="NumberFilterOptionEnum.CHOOSE"
                   class="radio-button"
                   formControlName="option"
                   id="{{filterName}}-operator"
                   name="option"
                   type="radio">
            <div class="text-radio-input">
                <app-input-dropdown #operator
                                    (inputValueChange)="onOperatorChange($event)"
                                    (inputBlur)="onOperatorBlur($event)"
                                    [alternateBackground]="true"
                                    [baseCypressTag]="getCypressTagElement('dropdown-operator')"
                                    [inputFormatter]="operatorOptionFormatter"
                                    [resultFormatter]="operatorOptionFormatter"
                                    [resultsFunction]="operatorFilterFunction"
                                    placeholder="Choose one">
                </app-input-dropdown>
            </div>
        </div>
        <div class="dropdown-container input-options">
            <app-input-text #defaultInput
                            (inputValueChange)="updateDefaultValue($event)"
                            (keydown.enter)="closeAndSearch()"
                            [alternateBackground]="true"
                            [class]="showExtraInputFieldClass"
                            [hasLabel]="false"
                            [isDisabled]="true"
                            baseCypressTag="start"
                            [placeholder]="getOperatorPlaceholder()"></app-input-text>
            <span [hidden]="!showExtraInputField">
                <span class="input-separator-text">and</span>
                <app-input-text #extraInput
                                (inputValueChange)="updateExtraValue($event)"
                                (keydown.enter)="closeAndSearch()"
                                [alternateBackground]="true"
                                [class]="showExtraInputFieldClass"
                                [hasLabel]="false"
                                baseCypressTag="end"></app-input-text>
            </span>
        </div>
        <app-filter-footer (applyClick)="closeAndSearch()"
                           (clearClick)="clear()"
                           [filterName]="filterName"></app-filter-footer>
    </form>
</div>

